
<div class="popup-wrapper">
  <div class="close-btn">
    <i class="material-icons" (click)="handleCloseAndSendEvent('closeBtn')">close</i>
  </div>
 <div class="top-img-wrapper">
   <img loading="lazy" [attr.data-src]="'/assets/images/donation-confirmation-img.png'" />
 </div>
 <div class="content">
   <div class="title">
     {{vars.showKCart ? info.extraProductTitle : info.title}}
   </div>
   <div class="description" [innerHTML]="vars.showKCart ? info.extraProductDescription() : !isMedical ? info.non_med_desc(utilService.capitalizeFirstLatter(beneficiaryName)) : info.description(beneficiaryName, data?.contributeDetails?.min_donation, utilService.getCurrencyIcon(data?.currency).symbol)">
   </div>
 </div>
 <div class="action-wrapper">
   <app-button label="Yes, I will help" btnClass="full-width" (click)="handleCloseAndSendEvent('help')"></app-button>
   <button mat-button  class="full-width" (click)="handleCloseAndSendEvent('cancel')">
     Sorry, not today
   </button>
 </div>
</div>
